"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = factorial;
let toBigInt;

try {
  toBigInt = BigInt(1) && (n => BigInt(n));
} catch (e) {
  toBigInt = n => n;
}

function factorial(n) {
  if (n === 0 || n === 1) return toBigInt(1);
  return toBigInt(n) * toBigInt(factorial(n - 1));
}

module.exports = exports["default"];